/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import { Technology } from '../../models/technology.model';
import {
  retrieveTechnologiesFailure,
  retrieveTechnologiesSuccess,
} from '@store/price-card/technology/technology.slice';

export const retrieveTechnologiesEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('technologies/retrieveTechnologies'),
    concatMap((_action: Action) =>
      from(dependencies.technologyGateway.retrieveAll()).pipe(
        map((technologies: Technology[]) => retrieveTechnologiesSuccess(technologies)),
        catchError(() => of(retrieveTechnologiesFailure('Fail to retrieve technologies'))),
      ),
    ),
  );
